import * as actionTypes from './actionTypes';
import { apiService } from '../../utils/api';
import type { AppDispatch } from '../store';
import type {
  NotificationConnectionStatus,
  NotificationEnvelope,
  NotificationRestItem,
  NotificationSnapshot,
} from '@/features/notifications/types';

export const notificationsSnapshot = (snapshot: NotificationSnapshot) => ({
  type: actionTypes.NOTIFICATIONS_SNAPSHOT,
  data: snapshot,
});

export const setNotifications = (items: NotificationRestItem[]) => ({
  type: actionTypes.NOTIFICATIONS_SET,
  data: { items },
});

export const notificationAdded = (envelope: NotificationEnvelope) => ({
  type: actionTypes.NOTIFICATION_ADDED,
  data: { envelope },
});

export const notificationMarkedRead = (id: string) => ({
  type: actionTypes.NOTIFICATION_MARKED_READ,
  data: { id },
});

export const notificationsAllRead = () => ({
  type: actionTypes.NOTIFICATIONS_ALL_READ,
});

export const notificationRemoved = (id: string) => ({
  type: actionTypes.NOTIFICATION_REMOVED,
  data: { id },
});

export const setNotificationsUnreadCount = (unreadCount: number) => ({
  type: actionTypes.NOTIFICATIONS_SET_UNREAD_COUNT,
  data: { unreadCount },
});

export const setNotificationsConnection = (connection: NotificationConnectionStatus) => ({
  type: actionTypes.NOTIFICATIONS_SET_CONNECTION,
  data: { connection },
});

export const setNotificationsLoading = (loading: boolean) => ({
  type: actionTypes.NOTIFICATIONS_LOADING,
  data: { loading },
});

export const fetchNotifications = () => async (dispatch: AppDispatch) => {
  dispatch(setNotificationsLoading(true));
  try {
    const { data } = await apiService.get('/api/v1/notifications/', { silentError: true });
    const items: NotificationRestItem[] = Array.isArray(data) ? data : data?.results ?? [];
    dispatch(setNotifications(items));
  } catch (err) {
    console.log(err);
  } finally {
    dispatch(setNotificationsLoading(false));
  }
};

export const fetchUnreadCount = () => async (dispatch: AppDispatch) => {
  try {
    const { data } = await apiService.get('/api/v1/notifications/unread-count/', {
      silentError: true,
    });
    dispatch(setNotificationsUnreadCount(data?.unreadCount ?? 0));
  } catch (err) {
    console.log(err);
  }
};

export const markNotificationRead = (id: string) => async (dispatch: AppDispatch) => {
  dispatch(notificationMarkedRead(id));
  try {
    await apiService.patch(`/api/v1/notifications/${id}/read/`);
  } catch (err) {
    console.log(err);
  }
};

export const markAllNotificationsRead = () => async (dispatch: AppDispatch) => {
  dispatch(notificationsAllRead());
  try {
    await apiService.post('/api/v1/notifications/mark-all-read/');
  } catch (err) {
    console.log(err);
  }
};

export const dismissNotification = (id: string) => async (dispatch: AppDispatch) => {
  dispatch(notificationRemoved(id));
  try {
    await apiService.delete(`/api/v1/notifications/${id}/`);
  } catch (err) {
    console.log(err);
  }
};
